import React, { useEffect /* useEffect */ } from 'react'
import { ScrollView, SafeAreaView } from 'react-native'
import { useSelector } from 'react-redux'
// import ActionCreators from '../../store/actions'

// import styles from './styles'
import { HGView } from '../../components/HGUI'
// import Disclaimer from './Disclaimer'
// import Cooperation from './Cooperation'

const StartOverviewScreenScreen = (props) => {
  const { navigation } = props

  const { patientGroup } = useSelector((state) => state.user)

  const switchPatientGroup = () => {
    if (patientGroup === 'children')
      return navigation.replace('StartOverviewChildren')
    if (patientGroup === 'adults')
      return navigation.replace('StartOverviewAdults')
    if (patientGroup === 'caredependents')
      return navigation.replace('StartOverviewCaredependents')
  }

  useEffect(() => {
    switchPatientGroup()
  }, [patientGroup])

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <HGView>
        <ScrollView>
          {/* <HGText>Bitte wählen Sie Ihre gewünschte Patientengruppe</HGText> */}
        </ScrollView>
        {/* <HGFlatList
        data={listData}
        ListHeaderComponent={<HGHeading>Start</HGHeading>}
        ListFooterComponent={
          <>
            <Disclaimer />
            <Cooperation />
          </>
        }
        keyExtractor={(item) => item.key}
        style={styles.container}
      /> */}
      </HGView>
    </SafeAreaView>
  )
}

export default StartOverviewScreenScreen
